import React from "react";
import { Navigate } from "react-router-dom";

//layoutpages
import Default from "../layouts/dashboard/default";
import LandingPage from "../views/dashboard/landingPage";

import { DefaultRouter } from "./default-router";
import { Layout1Router } from "./layout1-router";

// Import sign-in and recoverpw components directly for root paths
import SignIn from "../views/dashboard/auth/sign-in";
import Recoverpw from "../views/dashboard/auth/recoverpw";
import Register from "../views/dashboard/register";
import FacebookCallback from "../views/dashboard/auth/facebook-callback";
import ChangePassword from "../views/dashboard/auth/change-password";
import RouteGuard from "../components/auth/RouteGuard";

export const IndexRouters = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <SignIn />,
  },
  {
    path: "/forgot-password",
    element: <Recoverpw />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/facebook-callback",
    element: <FacebookCallback />,
  },
  {
    path: "/change-password",
    element: (
      <RouteGuard>
        <ChangePassword />
      </RouteGuard>
    ),
  },
  {
    path: "/portal",
    element: (
      <RouteGuard>
        <Default />
      </RouteGuard>
    ),
    children: [
      {
        // Redirect from /portal to /portal/summary
        path: "",
        element: <Navigate to="/portal/summary" replace />,
      },
      ...DefaultRouter,
      ...Layout1Router,
    ],
  },
];
